/* eslint-disable camelcase */
export const checkIsCrossCampaignTrackingProperty = (isCrossCampaign) => isCrossCampaign ? '1' : '0';
export const checkIsGetInspiredTrackingProperty = (isGetInspired) => isGetInspired ? '1' : '0';
// TODO: validation required https://jira.zalando.net/browse/LCFAP-12972
export const getGA4Context = ({ isCrossCampaign, isGetInspired, isTopPickArticle, }) => {
    if (isCrossCampaign) {
        return 'cross_campaign_filter';
    }
    if (isGetInspired) {
        return 'is_get_inpired';
    }
    if (isTopPickArticle) {
        return 'tp4u';
    }
    return null;
};
export const TRACK_TRAFFIC_SOURCES = ['notification'];
export const getElementFromTrafficSource = (trafficSource) => {
    if (trafficSource && TRACK_TRAFFIC_SOURCES.includes(trafficSource)) {
        return trafficSource;
    }
    return null;
};
export const toPageTypeLvl1 = (page) => {
    switch (page) {
        case 'catalog':
            return 'catalog';
        case 'pdp':
            return 'pdp';
        case 'mylounge':
            return 'my_lounge';
        default:
            return null;
    }
};
const StockStatus = {
    RESERVED: 'RESERVED',
    SOLD_OUT: 'SOLD_OUT',
    AVAILABLE: 'AVAILABLE',
};
const checkAvailability = (stockStatus) => {
    const availability = {
        [StockStatus.AVAILABLE]: '0',
        [StockStatus.RESERVED]: '1',
        [StockStatus.SOLD_OUT]: '2',
    };
    return availability[stockStatus] || '0';
};
export const toItemAvailability = (stockStatus) => {
    const availability = {
        [StockStatus.AVAILABLE]: 'available',
        [StockStatus.RESERVED]: 'reserved',
        [StockStatus.SOLD_OUT]: 'sold_out',
    };
    return availability[stockStatus] || null;
};
export const formatItemName = ({ nameCategoryTag, nameColor, }) => {
    if (nameCategoryTag && nameColor) {
        return `${nameCategoryTag} - ${nameColor}`;
    }
    return nameCategoryTag || null;
};
export const formatPrice = (price) => {
    return price ? price / 100 : 0;
};
export const formattedSimples = (article, key = 'size') => {
    if (!article.simples) {
        return null;
    }
    return article.simples
        .map((s) => `${s[key]}|${checkAvailability(s.stockStatus)}`)
        .join(';');
};
export const mapArticleToGA4EcommerceItem = (item) => (Object.assign({ affiliation: null, article_size_recommendation: null, coupon: null, discount: null, early_access_item: null, feature_flag: null, index: null, is_sustainable: null, item_availability: null, item_brand: null, item_id: null, item_list_id: null, item_list_name: null, item_name: null, item_variant: null, location_id: null, price: null, product_delivery_dates: null, product_gender: null, promotion_id: null, quantity: null, recommended: null, size_availability: null }, item));
